import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

let showProgress = () => {};
let hideProgress = () => {};

export function triggerProgress() { showProgress(); }
export function stopProgress() { hideProgress(); }

export default function TopProgressBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    showProgress = () => setVisible(true);
    hideProgress = () => setVisible(false);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { delay: 0.15 } }}
          className="fixed top-0 left-0 right-0 z-[9999] h-[2.5px] pointer-events-none"
        >
          <motion.div
            initial={{ width: '0%' }}
            animate={{ width: ['0%', '55%', '78%', '92%'] }}
            transition={{ duration: 1.8, ease: 'easeOut' }}
            className="h-full bg-gradient-to-r from-[#1e3a5f] via-[#2563eb] to-[#60a5fa] rounded-r-full shadow-xs shadow-blue-500/30"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}

// Suspense fallback component — shows modern skeleton with dark support
export function PageLoader() {
  useEffect(() => {
    triggerProgress();
    return () => stopProgress();
  }, []);
  return (
    <div className="p-4 lg:p-6 space-y-4 max-w-5xl mx-auto">
      <div className="h-7 w-48 bg-[#e8e6e1] dark:bg-[#201f1d] rounded-lg animate-pulse" />
      <div className="h-28 bg-white dark:bg-[#161514] border border-[#e2e0db] dark:border-[#2e2d2b] rounded-xl animate-pulse p-4 space-y-3">
        <div className="h-4 w-36 bg-[#e8e6e1] dark:bg-[#201f1d] rounded" />
        <div className="h-8 w-64 bg-[#e8e6e1] dark:bg-[#201f1d] rounded-md" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="h-24 bg-white dark:bg-[#161514] border border-[#e2e0db] dark:border-[#2e2d2b] rounded-xl animate-pulse" />
        <div className="h-24 bg-white dark:bg-[#161514] border border-[#e2e0db] dark:border-[#2e2d2b] rounded-xl animate-pulse" />
      </div>
      <div className="h-44 bg-white dark:bg-[#161514] border border-[#e2e0db] dark:border-[#2e2d2b] rounded-xl animate-pulse" />
    </div>
  );
}
